module.exports = __webpack_public_path__ + "img/cal-diners-stacked.3c0b5122.svg";